import { useEffect, useRef } from 'react';

const fit = (el) => { el.style.height = 'auto'; el.style.overflowY = 'hidden'; el.style.height = `${el.scrollHeight + 2}px`; };

// every textarea inside the returned ref grows to show all its text: no inner scrolling
export const useAutoGrow = (deps) => {
  const ref = useRef(null);
  useEffect(() => {
    const root = ref.current;
    if (!root) return undefined;
    root.querySelectorAll('textarea').forEach(fit);
    const onInput = (e) => { if (e.target.tagName === 'TEXTAREA') fit(e.target); };
    root.addEventListener('input', onInput);
    return () => root.removeEventListener('input', onInput);
  }, [deps]);
  return ref;
};
